module.exports = __webpack_public_path__ + "static/media/18_plantilla_cuadrada_combo_simple_cp_gaseosas_lata_354_ccsa.33020dac.png";